module.exports = __webpack_public_path__ + "linkedin-blue.png?6a1f757bfe4df363985951f57cfdf8a2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/linkedin-blue.png
// module id = 969
// module chunks = 0